import { DomainConf } from "@wwg/domain-conf";

/**
 * Define configurations here to be loaded based on the domain
 * the app is being served from.
 */
const env = new DomainConf()
  .forDomain("localhost", {
    apiBase: "https://dev-api.wwdb.com/v1/pulse",
    coreApiUrl: "https://dev-api.wwdb.com/v1/core/",
    localDevMode: true, // Set to true to enable local login for developers.
  })
  .forDomain("pulse-dev.wwdb.com", {
    apiBase: "https://dev-api.wwdb.com/v1/pulse",
    coreApiUrl: "https://dev-api.wwdb.com/v1/core/",
  })
  .forDomain("pulse.wwdb.dev", {
    apiBase: "https://dev-api.wwdb.com/v1/pulse",
    coreApiUrl: "https://dev-api.wwdb.com/v1/core/",
  })
  .forDomain("pulse-staging.wwdb.com", {
    apiBase: "https://api.wwdb.com/v1/pulse",
    coreApiUrl: "https://dev-api.wwdb.com/v1/core/",
  })
  .forDomain("pulse.wwdb.com", {
    apiBase: "https://api.wwdb.com/v1/pulse",
    coreApiUrl: "https://dev-api.wwdb.com/v1/core/",
  });

// Export the selected configuration from this file. You can import this wherever you need to use it.
export default env.current;
